<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              `${this.$t("staff.add.title")}`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("staff.add.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" class="">
                  <input
                    type="file"
                    name="profile_pic"
                    @change="changeFile($event)"
                    ref="profile_pic"
                    hidden
                  />
                  <v-badge bordered bottom overlap offset-x="20" offset-y="20">
                    <template v-slot:badge>
                      <v-icon
                        small
                        dark
                        @click="openFileExplorer"
                        class="edit-icon"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <v-avatar
                      size="120"
                      v-if="staff.picture_url != null"
                      class="cursor-pointer"
                      @click="openFileExplorer"
                    >
                      <img
                        :src="API_BASE_URL + '/uploads/' + staff.picture_url"
                        :alt="staff.picture_url"
                      />
                    </v-avatar>
                    <v-avatar
                      v-if="staff.picture_url == null"
                      color="secondary"
                      class="white--text cursor-pointer imagePreviewWrapper"
                      :style="{ 'background-image': `url(${previewImage})` }"
                      size="120"
                      @click="openFileExplorer"
                    >
                    </v-avatar>
                  </v-badge>
                </v-col>
              </v-row>
              <span :class="`${serverSideErrors.picture ? 'red--text' : 'grey--text'}`" :style="{ marginBottom: '10px' }">
                {{ serverSideErrors.picture ? serverSideErrors.picture : "Only jpg, png, gif are allowed" }}
              </span>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="staff.name"
                    name="name"
                    label="Name"
                    v-validate="'required'"
                    :error="
                      errors.first('name') != null ||
                        serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('name') || serverSideErrors.name
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="staff.mobile_no"
                    name="ContactNo"
                    label="Contact No"
                    data-vv-as="Contact No"
                    v-validate="'required|numeric|max:10|min:10'"
                    :error="
                      errors.first('ContactNo') != null ||
                        serverSideErrors.mobile_no != null
                    "
                    :error-messages="
                      errors.first('ContactNo') || serverSideErrors.mobile_no
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="staff.designation"
                    name="designation"
                    label="Designation"
                    v-validate="'required'"
                    :error="
                      errors.first('designation') != null ||
                        serverSideErrors.designation != null
                    "
                    :error-messages="
                      errors.first('designation') ||
                        serverSideErrors.designation
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveStaffDetail"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
// import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      staff: {
        name: "",
        mobile_no: "",
        designation: "",
      },
      profile_pic: {},
      previewImage: null,
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),

    saveStaffDetail() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("name", this.staff.name);
          formData.append("mobile_no", this.staff.mobile_no);
          formData.append("designation", this.staff.designation);
          formData.append("picture", this.profile_pic);
          console.log("profile", this.profile_pic);
          _self.$axios
            .post("/societyadmin/staffs/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                _self.$router.push({ path: "/societyadmin/staff" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    openFileExplorer() {
      this.$refs.profile_pic.click();
    },
    changeFile(e) {
      this.profile_pic = e.target.files[0];
      let input = this.$refs.profile_pic;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
.imagePreviewWrapper {
  width: 120px;
  height: 120px;
  display: block;
  cursor: pointer;
  margin: auto;
  background-size: cover;
  background-position: center center;
}
</style>
